import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule, MatIconModule, MatInputModule, MatOptionModule, MatProgressSpinnerModule, MatSelectModule, MatToolbarModule, MatTooltipModule } from '@angular/material';
import { FcMaintenanceTypesInputModule } from '@core/components/fc-input/search-many/fc-maintenance-types-input/fc-maintenance-types-input.module';
import { FcOutlinedSelectModule } from '@core/components/fc-select/base/fc-outlined-select/fc-outlined-select.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { DialogConfirmDeleteCriteriasGroupComponent } from '../dialog-confirm-delete-criterias-group/dialog-confirm-delete-criterias-group.component';
import { DialogEditCriteriasGroupComponent } from './dialog-edit-criterias-group.component';


@NgModule({
  declarations: [
    DialogEditCriteriasGroupComponent
  ],
  imports: [
    CommonModule,
    TranslateModule.forRoot(),
    FuseSharedModule,

    FcMaintenanceTypesInputModule,
    MatIconModule,
    MatToolbarModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatInputModule,
    MatOptionModule,
    MatSelectModule,
    MatProgressSpinnerModule,

    FcOutlinedSelectModule,
    ReactiveFormsModule,
    NgxSkeletonLoaderModule
  ],
  exports: [
    DialogEditCriteriasGroupComponent
  ],
  entryComponents: [
    DialogConfirmDeleteCriteriasGroupComponent
  ]
})
export class DialogEditCriteriasGroupModule { }
